// generated by genversion
const version = '6.14.2';

export { version };
